type Inputs = {
    driverRoleInputElement: HTMLInputElement | null;
    driverOnlyFieldElements: NodeListOf<HTMLElement>;
}

function updateVisibility({ driverRoleInputElement, driverOnlyFieldElements }: Inputs) {
    if (!driverRoleInputElement) return;

    const shown = driverRoleInputElement.checked;
    driverOnlyFieldElements.forEach((element) => {
        element.hidden = !shown;
    });
}

export function toggleDriverOnlyFields({
    driverRoleInputElement,
    driverOnlyFieldElements,
}: Inputs) {
    if (!driverRoleInputElement || driverOnlyFieldElements.length === 0) return;

    driverRoleInputElement.addEventListener("change", () => {
        updateVisibility({ driverRoleInputElement, driverOnlyFieldElements });
    });

    updateVisibility({ driverRoleInputElement, driverOnlyFieldElements });
}
